import { render, staticRenderFns } from "./huovPrijsUitleg.vue?vue&type=template&id=10928f9a"
import script from "./huovPrijsUitleg.vue?vue&type=script&lang=js"
export * from "./huovPrijsUitleg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports